// @flow
import client, { saveJWTToken } from '../../client'

// Constants
export const CONFIRM_VERIFICATION_CODE_ENDPOINT =
  '/auth/users/validate_email_confirmation_code/'

/**
 * Validate the email confirmation code received in the email
 * @param {Object} data Confirmation data
 * @param {string} data.key User verification key
 * @param {string} data.confirmation_code Email confirmation code
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const confirmVerificationCode = (data: {
  key: string,
  confirmation_code: string,
}): Promise<any> =>
  client
    .post(CONFIRM_VERIFICATION_CODE_ENDPOINT, {
      body: data,
    })
    .then((res) => {
      saveJWTToken(res)
      return res.success
    })

export default confirmVerificationCode
